"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var image_1 = __importDefault(require("next/image"));
var react_1 = __importStar(require("react"));
var ProfileDropDown_1 = __importDefault(require("./ProfileDropDown"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var Profile = function (_a) {
    var _b;
    var isNarrowXl = _a.isNarrowXl, withReferral = _a.withReferral;
    var playerName = (0, swr_hooks_1.usePlayerName)();
    var _c = (0, swr_hooks_1.usePlayerStatus)(), isLoading = _c.isLoading, currentLevelInfo = _c.currentLevelInfo;
    var _d = (0, react_1.useState)(false), isProfileOpen = _d[0], setIsProfileOpen = _d[1];
    var handleClickProfileInfo = (0, react_1.useCallback)(function () { return setIsProfileOpen(!isProfileOpen); }, [setIsProfileOpen, isProfileOpen]);
    var closeProfileDropdown = (0, react_1.useCallback)(function () { return setIsProfileOpen(false); }, [setIsProfileOpen]);
    var profileRef = (0, react_1.useRef)(null);
    (0, apps_shared_1.useClickOutside)(closeProfileDropdown, profileRef);
    if (isLoading)
        return null;
    return (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.profileInfoWrapper, " ").concat(isProfileOpen ? styles_module_scss_1.default.profileInfoWrapperSelected : '', " ").concat(!isNarrowXl ? styles_module_scss_1.default.big : ''), ref: profileRef },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.profileInfo, onClick: handleClickProfileInfo },
            react_1.default.createElement(image_1.default, { width: 55, height: 55, className: styles_module_scss_1.default.avatar, alt: "avatar", src: ((_b = currentLevelInfo === null || currentLevelInfo === void 0 ? void 0 : currentLevelInfo.images) === null || _b === void 0 ? void 0 : _b.small) ||
                    (apps_shared_1.userLevelsImages === null || apps_shared_1.userLevelsImages === void 0 ? void 0 : apps_shared_1.userLevelsImages['level0Default']) }),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.userName }, playerName),
            react_1.default.createElement(image_1.default, { className: "".concat(styles_module_scss_1.default.arrowIcon, " ").concat(isProfileOpen ? styles_module_scss_1.default.arrowIconSelected : ''), alt: "arrow", width: 14, height: 13, src: '/img/icons/whiteArrow.svg' })),
        isProfileOpen ? (react_1.default.createElement(react_1.Suspense, { fallback: false },
            react_1.default.createElement(ProfileDropDown_1.default, { closeProfileDropdown: closeProfileDropdown, withReferral: withReferral }))) : null));
};
exports.default = Profile;
